<style scoped>
.two-part {
  width: 50%;
  padding: 10px;
}
.form-group:not([class*=' col-']) {
  width: 100%;
  width: 33.333333%;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: -5px;
  padding-bottom: -5px;
}
.database-grid-class {
  min-height: 200px;
  max-height: 350px;
}
.right-aligned {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-bottom: 5px;
}
</style>
<style>
.cell-disabled input[readonly] {
    background-color: lightgray;
    color: blue;
}  
</style>
<template>
    <div>
      <div class="d-flex justify-content-between">
        <h4>Operation Summary</h4>
          <div>
            <DxButton
              icon="download"
              hint="Download operation summary excel file"
              :height="40"
              />
            <DxButton
              id="refreshButton"
              icon="revert"
              hint="Refresh"
              :height="40"
              @click="refreshGrid" />
          </div>
      </div>
      <br />
      <div>
        <p v-if="cumHours > 24">This operation took duration more than a day.</p>
        <div v-show="false">
          Set day start time: <input v-model="dayStartTime" width="150px" />
          <DxButton
              :visible="startTimeChanged"
              text="Set"
              hint="Set time when the day work starts"
              @click="setStartTime"
              />
        </div>
        <DxDataGrid
          id="today-grid"
          ref="refDataGrid"
            :data-source="customDataSource" 
            :show-borders="true"
            :show-column-lines="false"
            :show-row-lines="true"
            column-resize-mode="nextColumn"
            :allow-column-reordering="true"
            :allow-column-resizing="true"
            :cell-hint-enabled="true"
            :word-wrap-enabled="true"
            :column-auto-width="false"
            :focused-row-enabled="true"
            :height="500"
            @init-new-row="onInitNewRow"
            @row-inserting="onRowInserting"
            @row-inserted="onRowInserted"
            @row-updated="onRowUpdated"
            @row-removed="onRowRemoved"
            @saved="onSaved"
            @selection-changed="onRowSelected">
          <!--  @editor-preparing="onEditorPreparing"
          -->
            <DxEditing
              :allow-updating="editable"
              :allow-adding="editable && cumHours < 48"
              :allow-deleting="editable"
              :use-icons="true"
              mode="form"
            />
            <DxSorting mode='single' />
            <DxScrolling column-rendering-mode="standard"/>
            <DxSelection mode="single" />
            <DxRowDragging
              :allow-reordering="true"
              :on-reorder="onReorder"
              :show-drag-icons="false"
            />
            <DxColumn
              type="buttons"
              width="70"
            >
              <GridButton name="edit"/>
              <GridButton name="delete"/>
            </DxColumn>
            <DxColumn data-field="index" caption="No." sort-order="asc" width="50">
              <DxFormItem :visible="false"/>
            </DxColumn>
            <!-- DxColumn data-field="id" :visible="true" sort-order="asc" / -->
            <DxColumn caption="Duration">
            <DxColumn
              data-field="from"
              caption="From"
              width="50"
              :allow-editing="false"
              >
              <DxFormItem :visible="true" css-class="cell-disabled"/>
            </DxColumn>
            <DxColumn
              data-field="to"
              caption="To"
              width="50"
              :allow-editing="false" >
              <DxFormItem :visible="false"/>
            </DxColumn>
            
            <DxColumn
              data-field="hours"
              data-type="number"
              width="55"
              caption="Hours"
            >
              <DxRequiredRule />
              <DxCustomRule :validation-callback="validateHours" message="Total hours exceeds 48."/>
            </DxColumn>
            </DxColumn>
            <DxColumn
              :visible="true"
              data-field="description"
              caption="Description"
              width="300"
              height="100px"
              >
              <DxFormItem
                :col-span="2"
                :editor-options="{ height: 150 }"
                editor-type="dxTextArea"
                />
            </DxColumn>            

            <DxColumn
              data-field="endMd"
              data-type="number"
              caption="End MD"
              width="70"
            >
              <DxRequiredRule />
            </DxColumn>
            <DxColumn
              data-field="holeSize"
              caption="Hole Size"
              width="100"
            >
              <DxLookup
                :data-source="optionsComboHoleSize"
                value-expr="value"
                display-expr="text"/>
              >
              <DxRequiredRule />
            </DxColumn>
            <DxColumn
              data-field="activityCode"
              data-type="Activity Code"
              width="100"
              :calculate-display-value="displayActivityCode"
            >
              <DxLookup
                :data-source="comboOptionActivitycode"
                value-expr="value"
                display-expr="text"
              />
              >
              <DxRequiredRule />
            </DxColumn>
            <DxColumn
              data-field="subActivityCode"
              data-type="Sub Activity Code"
              width="100"
              :calculate-display-value="displaySubActivityCode"
            >
              <DxLookup
                :data-source="comboOptionSubactivitycode"
                value-expr="value"
                display-expr="text"
              />
            </DxColumn>
            <DxColumn
              data-field="activityCategory"
              data-type="Activity Category"
              width="70"
            >
              <DxLookup
                :data-source="comboOptionActivitycategory"
                value-expr="value"
                display-expr="text"
              />
              <DxRequiredRule />
            </DxColumn>
            <DxColumn
              data-field="nptCode"
              data-type="NPT Code"
              width="100"
              :calculate-display-value="displayNPTCode"
            >
              <DxLookup
                :data-source="comboOptionNptcode"
                value-expr="value"
                display-expr="text"
                :visible="true"
              />
            </DxColumn>            
            <DxColumn
              :visible="true"
              data-field="failedEquipment"
              caption="Failed Equipments"
              width="120"
              >
              <DxSelectBox 
                :data-source="failedEquipmentRecords"
                value-expr="value"
                display-expr="name" />
            </DxColumn>
              <!-- DxColumn :allow-editing="false" >
                <DxFormItem :editor-options="{ display: none }" />
              </DxColumn -->
          </DxDataGrid>
      </div>
      <br />
  </div>
</template>

<script>
import { formMethods, formComputed, fieldComputed, authComputed } from '@state/helpers'
import axios from 'axios'
import mapApiUrl from '@/src/utils/api-mapper'
import qs from 'querystring'

import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxLookup,
  DxScrolling,
  DxFormItem,
  DxButton as GridButton,
  DxRowDragging,
  DxSorting,
  DxRequiredRule,
  DxCustomRule,
  DxSelection,
  DxSelectBox
} from 'devextreme-vue/data-grid'
import DxTextBox from 'devextreme-vue/text-box'
import DxButton from 'devextreme-vue/button'
import 'devextreme-vue/text-area'
import notify from "devextreme/ui/notify"

import CustomStore from 'devextreme/data/custom_store'

/* const timeFormatter = event => {
  /* if (event.reverse) {
    return event.value && +event.value.replace(' years')
  } /
  const hours = (event.value / 60).toFixed(0)
  const minutes = (hours / 60).toFixed(0)
  const seconds = (minutes / 60).toFixed(0)
  const timeString = [hours,":",minutes,":",seconds].implode() 
  return `${timeString} years`
} */
// const klik = ref('click')
export default {
  components: {
    DxDataGrid, DxColumn, DxEditing, DxLookup, DxScrolling, DxFormItem, GridButton, DxRowDragging, DxSorting,
    DxRequiredRule, DxCustomRule, DxButton, DxTextBox, DxSelection, DxSelectBox
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    submitId: {
        type: Number,
        default: 0,
    },
    editable: {
        type: Boolean,
        default: false,
    },
    wellId: {
        type: Number,
        default: 0,
    },
    reportDate: {
        type: String,
        default: ""
    }
  },
  data() {
    return {
      selectedRow: [-1,-1],
      selectedKey: -1,
      dayStartTime: 0,
      cumHours: 0,
      maxDate: '',
      addRowTodayIsOn: false,
      startTimeChanged: false,
      optionsComboUnitSize: [],
      comboOptionPhasecode: [],
      comboOptionActivitycode: [],
      comboOptionSubactivitycode: [],
      comboOptionActivitycategory: [],
      comboOptionNptcode: [],
      optionsComboHoleSize: [],
      failedEquipmentRecords: ['magicom', 'dispenser', 'ac'],
      sourceSubmitId: 0,
      form: [],
      show: true,
      isDisabled: false,
      selectedAction: '',
      opsumData: [],
      columnsDataToday: [],
      columnsDataNextDay: [],
      reportIsLoading: false,
      customDataSource: null,
      optionSizes: ['4 1/2', '5', '5 1/2', '6 5/8', '7', '7 5/8', '7 3/4', '7 7/8', '8 5/8', '9 5/8', '9 7/8', '10 3/4', '11 3/4', '11 7/8', '12 1/4', '13 3/8', '13 1/2', '13 5/8', '14', '14 3/4', '16', '17 1/2', '18 5/8', '20', '22', '24', '26', '30', '32', '36', '40', '42'],
    }
  },
  computed: {
    ...formComputed,
    ...fieldComputed,
    ...authComputed,
    isFirstReport() {
      return this.reportDate.substring(0,10) === this.currentWell.spudDate.substring(0,10)
    }
  },

  watch: {
    submitId: function (value) {
      this.$refs.refDataGrid.instance.refresh()
    },
    dayStartTime() {
      this.startTimeChanged = true
    }
  },
  mounted() {},
  created: function () {
    this.init()
    this.loadCombo()
    this.getFailedEquipmentSuggestions()
  },
  methods: {
    ...formMethods,
    init() {
      
      this.customDataSource = new CustomStore({
        key: 'id',
        load: () => {
          const spudDate = new Date(this.currentWell.spudDate)
          const spudDateHour = spudDate.getHours() 
          const spudDateMin = spudDate.getMinutes()/60 
          if (this.isFirstReport) {
            this.cumHours = spudDateHour + spudDateMin
            console.log("cumhours "+this.cumHours)
          } else {
            this.cumHours = 0
          }
            
          this.dayStartTime = this.calculateTime(this.cumHours)

          const url = mapApiUrl('/api/form/master/operation-summary/list')
          let params={submitId: this.submitId}
          return axios.get(url, {params: params}).then((response) => {
            let result = { data: [], totalCount: response.totalCount}
            response.data.forEach((element,index) => {
              element.index = index + 1
              element.from = this.calculateTime(this.cumHours)
              this.cumHours += element.hours
              element.to = this.calculateTime(this.cumHours)
              result.data.push(element)
            })
            return result
          })
        },
        onLoaded: (result) => {
            // Result is the array of data received from your backend
            console.log("Store received this data:", result)
            
            // Check if the first item actually contains your key
            if (result && result.length > 0) {
                console.log("Sample item structure:", result[0])
            }
        },
        insert: (values) => {
          values.submitId = this.submitId
          values.dailyReportId = this.submitId
          delete values.index
          delete values.from
          delete values.to
          if (isNaN(values.id)) {
            delete values.id
          }
          const url = mapApiUrl('/api/form/master/operation-summary/add')
          return axios.post(url, qs.stringify(values)).then(response => response.data)
        },
        update: (key, values) => {
          values.submitId = this.submitId
          delete values.index
          delete values.from
          delete values.to
          values.id = key
          const url = mapApiUrl('/api/form/master/operation-summary/add')
          if (values.submitId === undefined) {
            values.submitId = this.submitId
          }
          return axios.post(url, qs.stringify(values)).then(response => response)
        },
        remove: (key) => {
          const url = mapApiUrl('/api/form/master/operation-summary/delete')
          return axios.delete(url + `?rowId=${key}&submitId=${this.submitId}`).then(response => response.data)
        },
      })
    },
    reconsolidation() {
      let index = this.columnsDataToday.length
      this.cumHours = 0
      for (const row of this.columnsDataToday) {
        this.cumHours += row.hours
      }
      this.columnsDataNextDay.sort((a, b) => a.index - b.index)
      this.columnsDataNextDay.forEach(row => {
        row.id = ++index
        row.index = index - this.columnsDataToday.length
        this.cumHours += row.hours
      })
    },
    /* onRowInserted(e) {
      console.log("ori")
      let items = e.component.getDataSource()._items
      e.data.index = items.length
      this.fillTimeColumns(items,0)      
      e.component.refresh()
    }, */
    
    onInitNewRow(e) {
      e.data.from = this.calculateTime(this.cumHours)
      let items = e.component.getDataSource()._items
      e.data.id = items.length + 1
    },

    fillTimeColumns(rowData, initialValue) {
      let sumHours = initialValue
      rowData.sort((a,b) => {return a.index - b.index})
      for (let i=0; i < rowData.length; i++) {
        let data = rowData[i]
        data.id = i + 1
        if (i === 0) { data.from = "00:00" }
        else { data.from = this.calculateTime(sumHours) }
        sumHours += parseFloat(data.hours)
        data.to = this.calculateTime(sumHours)
      }
    },
    onEditorPreparing(e) {
      if (e.parentType === 'dataRow' && e.dataField === 'failedEquipment') {

        e.editorName = 'dxSelectBox'

        e.editorOptions = {
          dataSource: this.failedEquipmentRecords,
          searchEnabled: true,
          showDropDownButton: false,
          acceptCustomValue: true,
          displayExpr:"name",
          valueExpr:"value"
        }
      }
    },
    onRowRemoved(e) {
      notify({ message: 'Data has been removed.', width: 500 }, 'success', 3000)
    },
    onRowInserted(e) {
      notify({ message: 'Data has been recorded.', width: 500 }, 'success', 3000)
    },
    onRowUpdated(e) {
      notify({ message: 'Data has been updated.', width: 500 }, 'success', 3000)
    },
    getFailedEquipmentSuggestions() {
      const url=mapApiUrl('/api/form/master/operation-summary/get-failed-equipment-suggestions')
      axios.get(url).then(response => {
        this.failedEquipmentRecords = Array.from(response.data).map(x=>({name: x, value:x}))
      })
    },
    setStartTime(e) {
      // this.cumHours = Math.parse(this.dayStartTime.substring(0,2)+Math.parse(this.dayStartTime.substring(3,5)))/60.0
    },
    validateHours(value) {
      let sumHours = 0
      for (const entry of this.columnsDataToday) {
        if (value.data.id !== entry.id)
          sumHours += entry.hours
      } 
      return (sumHours + value.data.hours) <= 48 
    },
    convertFrom(rowData) {
      return this.calculateTime(rowData.from)
    },
    convertTo(rowData) {
      return this.calculateTime(rowData.to)
    },
    setFieldTo(rowData) {
      return rowData.from + rowData.hours
    },
    displayPhaseCode(rowData) {
      return rowData.phaseCode
    },
    displayActivityCode(rowData) {
      return rowData.activityCode
    },
    displaySubActivityCode(rowData) {
      return rowData.subActivityCode
    },
    displayNPTCode(rowData) {
      return rowData.nptCode
    },
    calculateTime(value) {
      if (value === undefined) return "00:00"
      if (value >= 24) value -= 24
      let remain = value * 3600
      const hours = Math.floor(value)
      remain = (value - hours) * 3600
      const minutes = Math.floor(remain / 60)
      const timeString = hours.toString().padStart(2,'0') + ":" + minutes.toString().padStart(2,'0')
      return timeString
    },
    refreshGrid() {
      this.customDataSource.load()
      this.$refs.refDataGrid.instance.refresh()
    },
    onSaved() {
      this.getFailedEquipmentSuggestions()
    },
    deleteRow() {
      this.reportIsLoading = true
      axios.delete(
          mapApiUrl("/api/form/master/operation-summary/delete?rowId="+this.selectedKey+"&submitId="+this.submitId))
          // {params: { id: this.selectedKey, submitId: this.submitId }})
      .then((response) => {
            this.reportIsLoading = false
            if (response.data === true) {
              notify({ message: 'The selected row was deleted', width: 500 }, 'success', 1000)
            } else {
              notify({ message: 'The selected row was NOT deleted', width: 300 }, 'danger', 1000)
            }
          })
    },
    onRowSelected(e) {
      this.selectedKey = e.currentSelectedRowKeys
    },
    onKeyDown(e) {
      if (e.event.originalEvent.code === "Enter") {
        e.component.editRow(e.component.focusedRow)
      } else if (e.event.originalEvent.code === "Delete") {
        this.deleteRow()
      }
      console.log(e)
    },
    onRowInserting(e) {
      let changesData = e.data
      
      if (changesData.activityCategory === "PT") {
        changesData.nptCode = null
      }
      e.cancel = false
    },
    onReorder(e) {
      let dataItems = e.component.getDataSource()._items
      const visibleRows = e.component.getVisibleRows()
      const toIndex = dataItems.find((item) => item.id === visibleRows[e.toIndex].data.id)
      const fromIndex = dataItems.find((item) => item.id === e.itemData.id)
      const toIndexId = toIndex.index

      dataItems.forEach(element => {
        if (element.index === fromIndex.index) {
        } 
        else if (fromIndex.index > toIndex.index) { 
          if (element.index >= toIndex.index && element.index < fromIndex.index) {
            element.index++
          }
        } else if (element.index > fromIndex.index && element.index <= toIndex.index) {
          element.index--
        }
      })
      fromIndex.index = toIndexId
      e.component.refresh()
    },
    convertNomSize(nom) {
      if (!isNaN(nom)) return nom
      let sizeStrings = nom.split(" ")
      let sizeValue = parseFloat(sizeStrings[0])
      if (sizeStrings.length > 1) {
        let element = sizeStrings[1].split("/")
        let elementsValue = parseFloat(element[0]) / parseFloat(element[1])
        sizeValue += elementsValue
      }
      return sizeValue
    },
    loadComboHoleSize() {
      this.getComboListWorkstringSize({ params: {} }).then((resp) => {
        let _arrData = resp.data.data
        _arrData.sort((x,y)=>this.convertNomSize(x.comboValue)-this.convertNomSize(y.comboValue))
        this.optionsComboHoleSize = []
        for (var i = 0; i < _arrData.length; i++) {
          let _temp = {
            value: _arrData[i].comboId,
            text: _arrData[i].comboValue,
          }
          this.optionsComboHoleSize.push(_temp)
        }
      })
    },
    async loadLastDateValue() {
      let data = null
      await this.getOpsSumMaxDate({ params: { wellId: this.wellId } }).then(
        (resp) => {
          this.maxDate = resp.data.data
          // return data
        }
      )
      return data
    },
    loadCombo() {
      this.loadComboHoleSize()
      this.getComboOptionActivitycode({ params: {} }).then((resp) => {
        let _arrData = resp.data.data
        this.comboOptionActivitycode = []
        for (var i = 0; i < _arrData.length; i++) {
          let _temp = {
            value: _arrData[i].comboId,
            text: _arrData[i].comboValue,
          }
          this.comboOptionActivitycode.push(_temp)
        }
      })

      this.getComboOptionSubactivitycode({ params: {} }).then((resp) => {
        let _arrData = resp.data.data
        this.comboOptionSubactivitycode = []
        for (var i = 0; i < _arrData.length; i++) {
          let _temp = {
            value: _arrData[i].comboId,
            text: _arrData[i].comboValue,
          }
          this.comboOptionSubactivitycode.push(_temp)
        }
      })

      this.getComboOptionActivitycategory({ params: {} }).then((resp) => {
        let _arrData = resp.data.data
        this.comboOptionActivitycategory = []
        for (var i = 0; i < _arrData.length; i++) {
          let _temp = {
            value: _arrData[i].comboId,
            text: _arrData[i].comboValue,
          }
          this.comboOptionActivitycategory.push(_temp)
        }
      })

      this.getComboOptionNptcode({ params: {} }).then((resp) => {
        let _arrData = resp.data.data
        this.comboOptionNptcode = []
        for (var i = 0; i < _arrData.length; i++) {
          let _temp = {
            value: _arrData[i].comboId,
            text: _arrData[i].comboValue,
          }
          this.comboOptionNptcode.push(_temp)
        }
      })
    },
  },
}
</script>
